
export const IMETAMessageType = {
    AIRequest : 1,
    UEActor : 20,
    UESpeak : 21,
    UEStopSpeak: 22,
    UEBackground : 19,
    MMServer: 40,
    MMResponse: 41,
    TNList: 50,
    TNListResponse:51,
    CFGInfoUpdate:60,
    ADMINCommand:70,
    ADMINResponse:71,
    FROMADMINCommand:72,
}